
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 37 37"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.445 17.444V1a1 1 0 00-2 0v16.444H1a1 1 0 000 2h16.445V35.89a1 1 0 002 0V19.444h16.444a1 1 0 000-2H19.445z"}})])
          )
        }
      }
    